import {
  Forms as FormsIcon,
} from "../../Components/Icon";


import Forms from "../../Pages/Forms";

const navigation = {
  header: "Forms",
  links: [
    { text: "Forms", icon: FormsIcon, route: "forms", component: Forms },
  ],
};
export default navigation;
